import {format, parseISO} from "date-fns";
import React from "react";

const DateFormatDisplay = ({ value, formatString = "dd/MM/yyyy" }) => <>{value && format(parseISO(value), formatString)}</>;

export default DateFormatDisplay;
